import _ from 'lodash'
import React, { useState, useEffect, useRef } from 'react'
import { Icon } from '@ant-design/compatible'
import { UdTable, http } from '@ud/admin-framework'
import SelectedShow from '../SelectedShow'
import FilterDepartmentTree from '../FilterDepartmentTree'
import '../modalPublicStyle.less'

const columns = [
  { title: '工号', dataIndex: 'jobNumber' },
  { title: '姓名', dataIndex: 'name' },
  {
    title: '性别', dataIndex: 'gender', render: (text: any) => {
      return text === 'MALE' ? '男' : '女'
    }
  },
  { title: '部门名称', dataIndex: 'mainPostName' },
]

const SelectSuperiorLeader: React.FC<ISelectSuperiorLeaderProps> = (props) => {
  const [querying, setQuerYing] = useState<boolean>(false)
  const [dataSource, setDataSource] = useState<any[]>([])
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([])
  const [selectedRows] = useState<any[]>([])
  const [selectAllData, setSelectAllData] = useState<any[]>([])
  const [currentDepartment, setCurrentDepartment] = useState<any>({})

  const rowSelection = {
    onChange: (keysArr: any, rowArr: any) => {
      setSelectedRowKeys(keysArr)
      let arr: any = selectAllData
      arr.push(...rowArr)
      setSelectAllData(_.uniqBy(arr, 'jobNumber'))
    },
    selectedRowKeys,
  };

  const deleteSelect = (v: any) => {
    const newSelectedRowKeys = _.remove(selectedRowKeys, (n) => n !== v.jobNumber)
    const newSelectedRows = _.remove(selectedRows, (n) => n.jobNumber !== v.jobNumber)
    rowSelection.onChange(newSelectedRowKeys, newSelectedRows)
  }

  const emptySelect = () => {
    rowSelection.onChange([], [])
  }

  const queryTableData = () => {
    setQuerYing(true)
  }

  useEffect(() => {
    props.getHandler(() => {
      return {
        selectedRowKeys,
        selectedRows: selectAllData,
      }
    })
  })

  useEffect(() => {
    let arr: any = []
    selectedRowKeys.forEach((v) => {
      const item = _.find(selectAllData, n => n.jobNumber === v)
      if (item) {
        arr.push(item)
      }
    })
    setSelectAllData(arr)
  }, [selectedRowKeys])

  useEffect(() => {
    const currentUser = props.currentUser
    if (currentUser && currentUser.selectedRows && currentUser.selectedRows.length === 1) {
      setCurrentDepartment({ directUnitName: currentUser.selectedRows[0].directUnitName, directUnitUid: currentUser.selectedRows[0].directUnitUid })
    }

  }, [props.currentUser])

  return (
    <div className="select-modal-style">
      <div className="left">
        <div className="tree-box">
          <FilterDepartmentTree currentUserDepartment={currentDepartment} selectTreeNode={(v: any) => {
            console.log('点击树', v)
          }} />
        </div>
      </div>
      <div className="content">
        <div className="table-box">
          <UdTable
            rowKey={"jobNumber"}
            loading={querying}
            columns={columns}
            dataSource={dataSource}
            useColumnCustomize={false}
            useExport={false}
            rowSelection={rowSelection}
            pagination={false}
          />
        </div>
      </div>
      <div className="right">
        <div className="title">
          已选人员
        </div>
        <div className="select-box">
          <SelectedShow deleteSelect={(v: any) => deleteSelect(v)} selectedRows={selectAllData} />
        </div>
        <div className="empty-box">
          <span onClick={emptySelect}>清空
          <Icon type="delete" />
          </span>
        </div>
      </div>
    </div>
  )
}

interface ISelectSuperiorLeaderProps {
  getHandler?: any
  currentUser?: any
}


export default SelectSuperiorLeader